module.exports = __webpack_public_path__ + "static/media/gmb-seal.3e75cb90.png";